import { render, staticRenderFns } from "./BreweryTwitter.vue?vue&type=template&id=6a6017a4&"
import script from "./BreweryTwitter.vue?vue&type=script&lang=js&"
export * from "./BreweryTwitter.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/components/beer-dash.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports